import { trackAction } from '@mindfulchefuk/lib/rum'

const SECURE_PAYMENT = 'secure-payment'
const MAKE_PAYMENT_ERROR = 'secure-payment-make-payment-error'
const VERIFY_PAYMENT_ERROR = 'secure-payment-verify-payment-error'
const IFRAME_ERROR = 'secure-payment-iframe-error'

type SecurePaymentStage =
  | 'make-payment'
  | 'use-challenge-url'
  | 'complete-challenge-url'
  | 'verify-payment'
  | 'complete-without-3ds'
  | 'complete-with-3ds'
  | 'payment-complete'
  | 'iframe-url-changed-with-cors-error'
  | 'error-without-3ds'
  | 'error-with-verify-payment'
  | 'error-with-make-payment'
  | 'error-with-iframe'
  | 'error-with-payment-complete'

interface SecurePaymentContext {
  stage: SecurePaymentStage
  data?: unknown
}

const addAction = (name: string, context: SecurePaymentContext) =>
  trackAction(name, context)

export const trackMakePayment = () =>
  addAction(SECURE_PAYMENT, { stage: 'make-payment' })

export const trackCompleteWithout3DS = () =>
  addAction(SECURE_PAYMENT, { stage: 'complete-without-3ds' })

export const trackUseChallengeURL = () =>
  addAction(SECURE_PAYMENT, { stage: 'use-challenge-url' })

export const trackIFrameCorsError = () =>
  addAction(SECURE_PAYMENT, {
    stage: 'iframe-url-changed-with-cors-error',
  })

export const trackCompleteChallengeURL = () =>
  addAction(SECURE_PAYMENT, { stage: 'complete-challenge-url' })

export const trackVerifyPayment = () =>
  addAction(SECURE_PAYMENT, { stage: 'verify-payment' })

export const trackCompleteWith3DS = () =>
  addAction(SECURE_PAYMENT, { stage: 'complete-with-3ds' })

export const trackPaymentComplete = () =>
  addAction(SECURE_PAYMENT, { stage: 'payment-complete' })

// Errors

export const trackErrorMakePaymentData = (data: unknown) =>
  addAction(MAKE_PAYMENT_ERROR, { stage: 'error-without-3ds', data })

export const trackErrorWithMakePayment = (data: unknown) => {
  addAction(MAKE_PAYMENT_ERROR, {
    stage: 'error-with-make-payment',
    data,
  })
}

export const trackErrorWithPaymentComplete = (data: unknown) => {
  addAction(MAKE_PAYMENT_ERROR, {
    stage: 'error-with-payment-complete',
    data,
  })
}

export const trackErrorWithVerifyPayment = (data: unknown) =>
  addAction(VERIFY_PAYMENT_ERROR, {
    stage: 'error-with-verify-payment',
    data,
  })

export const trackNonCorsIFrameError = (data: unknown) =>
  addAction(IFRAME_ERROR, {
    stage: 'error-with-iframe',
    data,
  })
